import detector from '@/services/device-detector'

export default {
  install: (app) => {
    app.config.globalProperties.$isSmartphone = detector.isSmartphone
    app.provide('isSmartphone', detector.isSmartphone)

    app.config.globalProperties.$isMobile = detector.isMobile
    app.provide('isMobile', detector.isMobile)

    app.config.globalProperties.$isWindows = detector.isWindows
    app.provide('isWindows', detector.isWindows)

    app.config.globalProperties.$isIOS = detector.isIOS
    app.provide('isIOS', detector.isIOS)

    app.config.globalProperties.$isAndroid = detector.isAndroid
    app.provide('isAndroid', detector.isAndroid)

    app.config.globalProperties.$detector = detector
    app.provide('detector', detector)
  },
}
